import type { BulkActionResult } from '@/api/types/jobEnd.types';

// Leavers are skipped server-side rather than rejected, so the admin has to be told it happened -
// TerminationDate is not a column in the Job End table, making a silent skip indistinguishable from a send.
export function buildBulkReminderMessage(result: BulkActionResult): string {
  const skippedCount = result.skippedIds?.length ?? 0;
  const plural = result.processedCount !== 1 ? 's' : '';
  const skippedNote = skippedCount > 0
    ? ` ${skippedCount} skipped because the appraisee has left the business.`
    : '';

  return `${result.processedCount} reminder${plural} sent to the assigned Job End authors.${skippedNote}`;
}
